import { isResourceDetailBookmark, isResourceDetailHighlight, isResourceDetailImageBookmark } from '../../resources/utils/resourceDetailGuards.js';

const mutateWebpage = (originalWebpage, newData) => {
  return {
    title: newData.title ?? originalWebpage?.title,
    description: newData.description ?? originalWebpage?.description,
    image: newData?.image ? {
      ...originalWebpage?.image,
      ...newData.image
    } : originalWebpage?.image ?? null,
    favicon: originalWebpage?.favicon ?? null,
    html: originalWebpage?.html ?? null,
    reader: originalWebpage?.reader ?? null,
    screenshot: originalWebpage?.screenshot ?? null
  };
};
const mutateThumbnail = (originalThumbnail, newData) => {
  return newData?.image ? {
    lg: newData.image.url,
    md: newData.image.url,
    original: newData.image.url,
    sm: newData.image.url,
    xl: newData.image.url
  } : originalThumbnail ?? null;
};
const mutateResourceLinkPreview = (resource, newData) => {
  if (isResourceDetailBookmark(resource)) {
    return {
      ...resource,
      data: {
        ...resource.data,
        webpage: mutateWebpage(resource.data.webpage, newData)
      },
      thumbnail: mutateThumbnail(resource.thumbnail, newData)
    };
  }
  if (isResourceDetailHighlight(resource)) {
    return {
      ...resource,
      data: {
        ...resource.data,
        webpage: mutateWebpage(resource.data.webpage, newData)
      },
      thumbnail: mutateThumbnail(resource.thumbnail, newData)
    };
  }
  if (isResourceDetailImageBookmark(resource)) {
    return {
      ...resource,
      data: {
        ...resource.data,
        webpage: mutateWebpage(resource.data.webpage, newData)
      },
      thumbnail: mutateThumbnail(resource.thumbnail, newData)
    };
  }
  return resource;
};

export { mutateResourceLinkPreview };
//# sourceMappingURL=mutateResourceLinkPreview.js.map
